import { cloneDeep } from 'lodash';

//for the legacy endpoint that is grouped by department
export const complianceDataToEvents = (complianceData) => {
	let events = [];
	Object.entries(complianceData).forEach(([department, complianceDates]) => {
		complianceDates.forEach(complianceDate => {
			events.push(complianecDateToEvent(complianceDate));
		});
	});
	return events;
};

export const complianecDateToEvent = (complianceDate) => {
	return {
		date: complianceDate.date,
		title: `${complianceDate.department} - ${complianceDate.title}`,
	};
};

//new endpoint grouped by property with global dates
export const concatAllComplianceDates = (complianceData) => {
	const globalDates = complianceData?.global;
	let dates = [];

	if (globalDates) {
		dates = [].concat(globalDates);
	}

	if (complianceData?.properties) {
		Object.entries(complianceData?.properties).forEach(([propertyId, propertyDates])	=> {
			dates = dates.concat(propertyDates);
		});
	}
	return dates;
};

//returns compliance dates from new endpoint grouped by department (like the old endpoint)
export const groupComplianceDatesByDepartment = (dates) => {
	if (!dates) {
		return {};
	}
	let grouped = {};
	let items = dates;
	if (dates?.global && dates?.properties) {
		items = concatAllComplianceDates(dates);
	}
	if (Array.isArray(items)) {
		items.forEach((item) => {
			if (grouped[item.department]) {
				grouped[item.department].push(item);
			} else {
				grouped[item.department] = [];
				grouped[item.department].push(item);
			}
		});
	}
	return grouped;
};


export const addPropertyIdToComplianceDates = (complianceData) => {
	let clonedData = cloneDeep(complianceData);
	if (clonedData?.properties) {
		Object.entries(clonedData?.properties).forEach(([propertyId, dateArray])	=> {
			dateArray.forEach(complianceDate => {
				complianceDate.propertyId = parseInt(propertyId);
			});
		});
	}
	return clonedData;
};